import Vue from 'vue'
import Router from 'vue-router'
import LayoutCms from '@/views/layout_cms'

Vue.use(Router)

const _import = require('./_import_' + process.env.NODE_ENV);
export default {
    path: '/',
    meta: {
      permission: true
    },
    component: LayoutCms,
    children: [
      {
        path: '/questionCms', //cms进入无登录状态试做
        name: 'questionCms',
        component: _import('question/index_cms'),
        meta: {
          permission: !1,
          allowBack: !0,
          noCache: !0
        }
      }
    ]
}


// WEBPACK FOOTER //
// ./src/router/layout_cms.js